import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AuthProvider } from './context/AuthContext';
import { msalConfig } from './utils/auth/Auth-utils';
import AccessUser from './AccessUser';

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement)

const renderApp = () => {
    root.render(
        <AuthProvider msalConfig={msalConfig}>
            <AccessUser>
                <App />
            </AccessUser>
        </AuthProvider>
    )

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
}

renderApp();